import { render, staticRenderFns } from "./BaseDataIterator.vue?vue&type=template&id=8177aa92"
import script from "./BaseDataIterator.vue?vue&type=script&lang=js"
export * from "./BaseDataIterator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports